import { cn } from "@/lib/utils"

const SkeletonBlock = ({ className }: { className?: string }) => (
  <span
    aria-hidden="true"
    className={cn(
      "terminal-skeleton-block terminal-skeleton-pulse block rounded-sm",
      className
    )}
  />
)

const SkeletonSection = ({ rows = 4 }: { rows?: number }) => (
  <section className="border-border-strong relative mt-4 mb-6 rounded-sm border px-4 pt-4 pb-2.5">
    <SkeletonBlock className="float-label bg-background h-3 w-24" />
    <div className="space-y-2 pt-1">
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className={cn(
            "file-row items-center justify-between gap-8",
            index > 0 && "file-row-rule"
          )}
        >
          <SkeletonBlock className="h-3 w-28" />
          <SkeletonBlock className="h-4 w-18" />
        </div>
      ))}
    </div>
  </section>
)

export const FileDetailSkeleton = () => (
  <div role="status" aria-label="Loading File" className="flex flex-col gap-8">
    <span className="sr-only">Loading File</span>
    <div className="flex flex-col items-start gap-6 @3xl/company-detail:flex-row">
      <div className="w-full @3xl/company-detail:w-80 @3xl/company-detail:shrink-0">
        <section className="border-border-strong relative rounded-sm border px-4 pt-4 pb-2.5">
          <SkeletonBlock className="float-label bg-background h-3 w-20" />
          <div className="space-y-2 pt-1">
            {Array.from({ length: 5 }, (_, index) => (
              <div
                key={index}
                className={cn(
                  "file-row items-center justify-between gap-6",
                  index > 0 && "file-row-rule"
                )}
              >
                <SkeletonBlock className="h-3 w-24" />
                <SkeletonBlock className="h-3 w-14" />
              </div>
            ))}
          </div>
        </section>
      </div>
      <div className="w-full min-w-0 @3xl/company-detail:flex-1">
        <div className="space-y-3 pt-1">
          <SkeletonBlock className="h-4 w-full" />
          <SkeletonBlock className="h-4 w-[94%]" />
          <SkeletonBlock className="h-4 w-[88%]" />
          <SkeletonBlock className="h-4 w-[70%]" />
        </div>
      </div>
    </div>
    <div className="flex flex-wrap gap-1.5">
      <SkeletonBlock className="h-8 w-20" />
      <SkeletonBlock className="h-8 w-24" />
      <SkeletonBlock className="h-8 w-28" />
      <SkeletonBlock className="h-8 w-20" />
    </div>
    <div className="grid gap-8 @5xl/company-detail:grid-cols-2">
      <SkeletonSection rows={4} />
      <SkeletonSection rows={3} />
      <SkeletonSection rows={5} />
      <SkeletonSection rows={4} />
    </div>
  </div>
)
